module.exports = __webpack_public_path__ + "media/images/yelp-logo-466fd35e3e27866fccd2c3350b281b7b.svg";